import { always } from 'ramda'
import { createReducer } from '../../utilities/miscellaneous'

export const INITIAL_STATE = {
  isFetching: true,
  filters: {
    keyword: '',
  },
  page: 1,
  size: 24,
  total: 0,
  articles: [],
  error: false,
}

export const SEARCH = 'search/SEARCH'
export const FETCH = 'search/FETCH'
export const RECEIVED = 'search/RECEIVED'
export const ERROR = 'search/ERROR'

// search :: String -> Action
export const search = keyword => ({
  type: SEARCH,
  keyword,
})

// fetch :: Number -> Action
export const fetch = page => ({
  type: FETCH,
  page,
})

// received :: (Array, Number) -> Action
export const received = (articles, total) => ({
  type: RECEIVED,
  articles: articles || [],
  total,
})

// error :: () -> Action
export const error = always({ type: ERROR })

// search :: (State, Action *) -> State
export default createReducer(INITIAL_STATE, {
  [SEARCH]: (state, { keyword }) => ({
    ...state,
    filters: {
      ...state.filters,
      keyword,
    },
  }),

  [FETCH]: (state, { page }) => ({
    ...state,
    page,
    isFetching: true,
    error: false,
  }),

  [RECEIVED]: (state, { articles, total }) => ({
    ...state,
    total,
    articles,
    isFetching: false,
    error: false,
  }),

  [ERROR]: state => ({
    ...state,
    isFetching: false,
    error: true,
  }),
})
